var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-grid-vue',{staticClass:"ag-theme-alpine",staticStyle:{"width":"100%","height":"450px"},attrs:{"gridOptions":_vm.gridOptions,"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"rowSelection":_vm.rowSelection,"suppressDragLeaveHidesColumns":"","checkboxSelection":"true","suppressMovableColumns":""},on:{"grid-ready":_vm.onGridReady}})
}
var staticRenderFns = []

export { render, staticRenderFns }